<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_reset === true">รีเซ็ตรหัสผ่านเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-3">
          <v-divider />
          <v-tabs grow color="#8cc63e">
            <v-tab @click="page(1)" style="font-size: 18px">เงินสด</v-tab>
            <v-tab @click="page(2)" style="font-size: 18px">เครดิต</v-tab>
          </v-tabs>
          <v-divider />
          <div v-if="loading_data === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="text-right mt-2"
              v-if="$store.state.status == 1 || $store.state.userDetail.manage_customer_create == 1">
              <router-link to="/addcustomer" v-if="title_add === 1">
                <v-btn height="65" class="white--text grad-success-bg btn_mobile"
                  color="#8cc63e">เพิ่มลูกค้าส่งเงินสด</v-btn>
              </router-link>
              <router-link to="/addcustomercredit" v-if="title_add === 2">
                <v-btn height="65" class="white--text grad-success-bg btn_mobile"
                  color="#8cc63e">เพิ่มลูกค้าส่งเครดิต</v-btn>
              </router-link>
            </div>
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
                hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="all_customer" :footer-props="footer_Props" :search="search"
              mobile-breakpoint="0">
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.customer_code }}</td>
                  <td>{{ dataDetail.item.name }}</td>
                  <td v-if="title_add === 2">
                    <div v-if="dataDetail.item.credit != null">
                      <div>{{ format_number(dataDetail.item.credit) }} บาท</div>
                    </div>
                    <div v-else>0</div>
                  </td>
                  <td>{{ dataDetail.item.telephone }}</td>
                  <td><v-switch color="#8cc63e" @change="changeStatus(dataDetail.item.id, dataDetail.item.status)"
                      v-model="dataDetail.item.status" :disabled="disabled_status"></v-switch></td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="getDetails(dataDetail.item.id)"
                      class="grad-success-bg white--text mr-1 mb-1"
                      v-if="$store.state.status == 1 || $store.state.userDetail.manage_customer_list == 1"
                      title="ดูรายละเอียด">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="getEdit(dataDetail.item.id)"
                      class="grad-warning-bg white--text mr-1 mb-1"
                      v-if="$store.state.status == 1 || $store.state.userDetail.manage_customer_edit == 1"
                      title="แก้ไขข้อมูล">
                      <v-icon>mdi-note-edit-outline</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="delAlert(dataDetail.item.id)" class="grad-danger-bg white--text mb-1"
                      v-if="$store.state.status == 1 || $store.state.userDetail.manage_customer_delete == 1" title="ลบ">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                  <td v-if="$store.state.status === 1">
                    <v-btn small height="42" @click="password_reset(dataDetail.item.id)"
                      class="grad-main-bg white--text mr-1 mb-1" title="รีเซ็ตรหัสผ่าน">
                      รีเซ็ตรหัสผ่าน
                    </v-btn>
                  </td>
                  <!-- <td v-if="dataDetail.item.is_clinic == 0">
                    <v-btn small height="42" @click="open_pos(dataDetail.item.customer_code)"
                      class="pos-main-bg white--text mr-1 mb-1" title="เปิด POS">
                      เปิด POS
                    </v-btn>
                  </td> -->
                  <td v-if="dataDetail.item.POS_open == 1">
                    <a href="customerdashboard" class="text-success">ดูร้านค้า</a>
                  </td>
                  <td v-else>
                    <v-btn small height="42" @click="open_pos(dataDetail.item.customer_code, dataDetail.item.id)"
                      class="pos-main-bg white--text mr-1 mb-1" title="เปิด POS">
                      เปิด POS
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
        <!-- MODAL -->
        <v-dialog v-model="modal_details" max-width="900">
          <div v-if="loading_modal === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <v-form ref="add_form" @submit.prevent="">
                <v-card-title>
                  รายละเอียด
                </v-card-title>
                <v-card-text>
                  <div class="tri_grid border_input">
                    <div class="mt-3 mb-3 mr-1">
                      <div class="d-flex">
                        <div class="ml-2">รหัสสมาชิก : {{ details_get.code }}</div>
                      </div>
                    </div>
                    <div class="mt-3 mb-3 mr-1" v-if="details_get.type === 1">
                      <div class="d-flex">
                        <div class="ml-2">ประเภท : บุคคลธรรมดา <span
                            v-if="details_get.is_clinic == 1">(ลูกค้าคลีนิค)</span></div>
                      </div>
                    </div>
                    <div class="mt-3 mb-3 mr-1" v-if="details_get.type === 2">
                      <div class="d-flex">
                        <div class="ml-2">ประเภท : นิติบุคคล <span v-if="details_get.is_clinic == 1">(ลูกค้าคลีนิค)</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3 mb-3 mr-1 grid_flex">
                      <div class="ml-2">เลขประจำตัวผู้เสียภาษี</div>
                      <div class="ml-2 mr-2 grey--text">{{ details_get.tax_number }}</div>
                    </div>
                  </div>
                  <div class="ml-1 mt-4 mb-7" style="font-size: 20px">ข้อมูลส่วนตัว</div>
                  <div>
                    <div class="grid_half mt-n4 border_input">
                      <div class="mt-3 mb-2 mr-1 grid_flex">
                        <div class="d-flex">
                          <div><v-icon>mdi-account-outline</v-icon></div>
                          <div class="ml-2 mt-1 mr-2">ชื่อ-สกุล</div>
                        </div>
                        <div class="ml-2 mt-1 grey--text">{{ details_get.name }}</div>
                      </div>
                      <div class="mt-3 mr-1 grid_flex">
                        <div class="d-flex">
                          <div><v-icon>mdi-phone-outline</v-icon></div>
                          <div class="ml-2 mt-1 mr-2">เบอร์โทรสำหรับเข้าสู่ระบบ</div>
                        </div>
                        <div class="ml-2 mt-1 grey--text">{{ details_get.telephone }}</div>
                      </div>
                      <div class="mt-3 mr-1 mb-2 grid_flex">
                        <div class="d-flex">
                          <div><v-icon>mdi-email-outline</v-icon></div>
                          <div class="ml-2 mt-1 mr-2">อีเมล</div>
                        </div>
                        <div class="ml-2 mt-1 grey--text">{{ details_get.email }}</div>
                      </div>
                      <div class="mt-3 mr-1 grid_flex" v-if="details_get.customer_type === 2">
                        <div class="d-flex">
                          <div><v-icon>mdi-credit-card-outline</v-icon></div>
                          <div class="ml-2 mt-1 mr-2">ยอดเครดิต</div>
                        </div>
                        <div class="ml-2 mt-1 grey--text" v-if="details_get.credit_balance != null">{{
                          format_number(details_get.credit_balance)
                        }} บาท</div>
                        <div class="ml-2 mt-1 grey--text" v-if="details_get.credit_balance == null">0 บาท</div>
                      </div>
                      <div class="mt-3 mr-1 mb-4 grid_flex" v-if="details_get.customer_type === 2">
                        <div class="d-flex">
                          <div><v-icon>mdi-credit-card-outline</v-icon></div>
                          <div class="ml-2 mt-1 mr-2">กำหนดจำนวนวันในการติดเครดิต</div>
                        </div>
                        <div class="ml-2 mt-1 grey--text" v-if="details_get.credit_day !== null">{{
                          format_number(details_get.credit_day)
                        }} วัน</div>
                        <div class="ml-2 mt-1 grey--text" v-if="details_get.credit_day === null">0 วัน</div>
                      </div>
                    </div>
                    <div>
                      <div class="d-flex">
                        <v-icon>mdi-home</v-icon>
                        <div class="ml-1 mt-4 mb-4" style="font-size: 20px">ที่อยู่ในการจัดส่ง</div>
                      </div>
                      <div class="border_input">
                        <div class="grid_full">
                          <div class="mt-3">
                            <div class="ml-1">บ้านเลขที่/ที่อยู่ <span v-if="details_get.is_deliveryfreecnx === 1">(ส่งฟรีในเชียงใหม่)</span> <span v-if="details_get.customer_paylater === 1">(ส่งก่อนจ่ายเงินทีหลัง)</span></div>
                            <div class="ma-3 grey--text">{{ details_get.address }} </div>
                          </div>
                        </div>
                        <div class="four_grid">
                          <div class="mt-3 mr-1">
                            <div class="ml-1">ตำบล/แขวง</div>
                            <div class="ma-3 grey--text">{{ details_get.sub_district }}</div>
                          </div>
                          <div class="mt-3 mr-1">
                            <div class="ml-1">อำเภอ/เขต</div>
                            <div class="ma-3 grey--text">{{ details_get.district }}</div>
                          </div>
                          <div class="mt-3 mr-1">
                            <div class="ml-1">จังหวัด</div>
                            <div class="ma-3 grey--text">{{ details_get.province }}</div>
                          </div>
                          <div class="mt-3 mr-1">
                            <div class="ml-1">รหัสไปรษณีย์</div>
                            <div class="ma-3 grey--text">{{ details_get.postcode }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="details_get.type == 2">
                      <div class="mt-3 mb-2 d-flex">
                        <v-icon>mdi-home</v-icon>
                        <div class="ml-1 mt-2 mb-2" style="font-size: 20px">ที่อยู่ในการออกเอกสาร</div>
                      </div>
                      <div class="border_input">
                        <div class="grid_full">
                          <div class="mt-3">
                            <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                            <div class="ma-3 grey--text">{{ details_get.address_delivery }}</div>
                          </div>
                        </div>
                        <div class="four_grid">
                          <div class="mt-3 mr-1">
                            <div class="ml-1">ตำบล/แขวง</div>
                            <div class="ma-3 grey--text">{{ details_get.sub_district_delivery }}</div>
                          </div>
                          <div class="mt-3 mr-1">
                            <div class="ml-1">อำเภอ/เขต</div>
                            <div class="ma-3 grey--text">{{ details_get.district_delivery }}</div>
                          </div>
                          <div class="mt-3 mr-1">
                            <div class="ml-1">จังหวัด</div>
                            <div class="ma-3 grey--text">{{ details_get.province_delivery }}</div>
                          </div>
                          <div class="mt-3 mr-1">
                            <div class="ml-1">รหัสไปรษณีย์</div>
                            <div class="ma-3 grey--text">{{ details_get.postcode_delivery }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-spacer></v-spacer>
                <div class="text-center pa-4">
                  <v-btn large class="grad-danger-bg white--text mobile_btn" type="button" style="font-size: 18px"
                    @click="modal_details = false">
                    ปิด
                  </v-btn>
                </div>
              </v-form>
            </v-card>
          </div>
        </v-dialog>
        <v-dialog v-model="modal_edit" max-width="900">
          <div v-if="loading_modal === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <v-form ref="update_form" @submit.prevent="updateCustomer">
                <v-card-title>
                  แก้ไขรายละเอียด
                </v-card-title>
                <v-card-text>
                  <div class="grid_half">
                    <div class="mt-3 mr-1">
                      <div class="d-flex">
                        <v-icon>mdi-account</v-icon>
                        <div class="ml-1">รหัสสมาชิก : {{ details_get.code }}</div>
                      </div>
                    </div>
                    <div class="mt-n2">
                      <v-radio-group v-model="details_get.type">
                        <div class="d-flex justify-center">
                          <div class="d-flex mr-1">
                            <div>
                              <v-radio color="#86bc3a" :value="1"></v-radio>
                            </div>
                            <div>บุคคลธรรมดา</div>
                          </div>
                          <div class="d-flex ml-6">
                            <div>
                              <v-radio color="#86bc3a" :value="2"></v-radio>
                            </div>
                            <div>นิติบุคคล</div>
                          </div>
                        </div>
                      </v-radio-group>
                    </div>
                  </div>
                  <div>
                    <div class="grid_half">
                      <div class="mt-3 ml-1 mr-1">
                        <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline"
                          :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" hide-details="auto" v-model="details_get.name"
                          required outlined></v-text-field>
                      </div>
                      <div class="mt-3 ml-1 mr-1">
                        <v-text-field color="#86bc3a" label="เบอร์โทรสำหรับเข้าสู่ระบบ" type="tel" maxlength="11"
                          @keypress="isNumber($event, details_get.telephone)" prepend-inner-icon="mdi-phone-outline"
                          :rules="phoneRules" hide-details="auto" v-model="details_get.telephone" required
                          outlined></v-text-field>
                      </div>
                      <div class="mt-3 ml-1 mr-1 mb-4">
                        <v-text-field color="#86bc3a" label="อีเมล" type="email"
                          @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline"
                          hide-details="auto" v-model="details_get.email" outlined></v-text-field>
                      </div>
                      <div class="mt-3 ml-1 mr-1">
                        <v-text-field color="#86bc3a" label="เลขเสียภาษี" type="tel" maxlength="13"
                          @keypress="isTaxNumber($event, details_get.tax_number)"
                          prepend-inner-icon="mdi-card-account-details-outline" hide-details="auto"
                          v-model="details_get.tax_number" outlined></v-text-field>
                      </div>
                    </div>
                    <div class="d-flex align-center mt-3">
                      <div class="mt-n1 mb-4 mr-3">
                        <div class="d-flex align-center">
                          <v-checkbox color="#86bc3a" class="ma-0" v-model="details_get.is_clinic"
                            hide-details="auto"></v-checkbox>
                          <div>
                            ลูกค้าคลีนิค
                          </div>
                        </div>
                      </div>
                      <div class="mt-n1 mb-4 mr-3">
                        <div class="d-flex align-center">
                          <v-checkbox color="#86bc3a" class="ma-0" v-model="details_get.is_deliveryfreecnx"
                            hide-details="auto"></v-checkbox>
                          <div>
                            ส่งฟรีในเชียงใหม่
                          </div>
                        </div>
                      </div>
                      <div class="mt-n1 mb-4 mr-3">
                        <div class="d-flex align-center">
                          <v-checkbox color="#86bc3a" class="ma-0" v-model="details_get.customer_paylater"
                            hide-details="auto"></v-checkbox>
                          <div>
                            ส่งก่อนจ่ายเงินทีหลัง
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid_half mt-3" v-if="details_get.customer_type === 2">
                      <div class="mt-n1 mb-4">
                        <v-text-field color="#86bc3a" class="ml-1 mr-1" label="ยอดเครดิต" type="number"
                          prepend-inner-icon="mdi-credit-card-outline" hide-details="auto" :rules="creditRules"
                          @keypress="onlyNumberCredit($event, details_get.credit_balance)"
                          v-model="details_get.credit_balance" required outlined></v-text-field>
                      </div>
                      <div class="mt-n1 mb-4">
                        <v-text-field color="#86bc3a" class="ml-1 mr-1" label="กำหนดจำนวนวันในการติดเครดิต (วัน)"
                          type="number" prepend-inner-icon="mdi-credit-card-outline" :rules="credit_dayRules"
                          hide-details="auto" @keypress="onlyNumberCredit($event, details_get.credit_day)"
                          v-model="details_get.credit_day" required outlined></v-text-field>
                      </div>
                    </div>
                    <div>
                      <div class="d-flex">
                        <v-icon>mdi-home</v-icon>
                        <div class="ml-1">ที่อยู่ในการจัดส่ง</div>
                      </div>
                      <div class="grid_full">
                        <div class="mt-3">
                          <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                          <v-text-field class="mt-3 ml-1 mr-1" color="#86bc3a" placeholder="บ้านเลขที่/ที่อยู่"
                            hide-details="auto" v-model="details_get.address" outlined></v-text-field>
                        </div>
                      </div>
                      <div class="grid_half">
                        <div class="mt-3 ml-1 mr-1">
                          <addressinput-subdistrict :store="mainDataStore" class="custom_css" placeholder="ตำบล/แขวง"
                            v-model="details_get.sub_district" />
                        </div>
                        <div class="mt-3 ml-1 mr-1">
                          <addressinput-district :store="mainDataStore" class="custom_css" placeholder="อำเภอ/เขต"
                            v-model="details_get.district" />
                        </div>
                        <div class="mt-3 ml-1 mr-1">
                          <addressinput-province :store="mainDataStore" class="custom_css" placeholder="จังหวัด"
                            v-model="details_get.province" />
                        </div>
                        <div class="mt-3 ml-1 mr-1">
                          <addressinput-zipcode numbered :store="mainDataStore" class="custom_css"
                            placeholder="รหัสไปรษณีย์" v-model="details_get.postcode" />
                        </div>
                      </div>
                    </div>
                    <div v-if="details_get.type == 2">
                      <div class="grid_full">
                        <div class="mt-3">ที่อยู่ในการออกเอกสาร</div>
                        <v-radio-group v-model="details_get.is_delivery_same_address">
                          <div class="d-flex">
                            <div class="d-flex mr-1">
                              <div>
                                <v-radio color="#86bc3a" :value="0" @click="duplicate_address"></v-radio>
                              </div>
                              <div>เหมือนกัน</div>
                            </div>
                            <div class="d-flex ml-1">
                              <div>
                                <v-radio color="#86bc3a" :value="1" @click="unduplicate_address"></v-radio>
                              </div>
                              <div>ไม่เหมือนกัน</div>
                            </div>
                          </div>
                        </v-radio-group>
                      </div>
                      <div v-if="details_get.is_delivery_same_address === 1">
                        <div class="grid_full">
                          <div class="mt-3">
                            <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                            <v-text-field color="#86bc3a" class="mt-3 ml-1 mr-1" hide-details="auto" placeholder="ที่อยู่"
                              v-model="details_get.address_delivery" outlined></v-text-field>
                          </div>
                        </div>
                        <div class="grid_half">
                          <div class="mt-3 ml-1 mr-1">
                            <addressinput-subdistrict :store="subDataStore" class="custom_css" placeholder="ตำบล/แขวง"
                              v-model="details_get.sub_district_delivery" />
                          </div>
                          <div class="mt-3 ml-1 mr-1">
                            <addressinput-district :store="subDataStore" class="custom_css" placeholder="อำเภอ/เขต"
                              v-model="details_get.district_delivery" />
                          </div>
                          <div class="mt-3 ml-1 mr-1">
                            <addressinput-province :store="subDataStore" class="custom_css" placeholder="จังหวัด"
                              v-model="details_get.province_delivery" />
                          </div>
                          <div class="mt-3 ml-1 mr-1">
                            <addressinput-zipcode numbered :store="subDataStore" class="custom_css"
                              placeholder="รหัสไปรษณีย์" v-model="details_get.postcode_delivery" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-spacer></v-spacer>
                <div class="text-center pa-4">
                  <v-btn large class="grad-success-bg white--text mobile_btn" type="submit" style="font-size: 18px">
                    แก้ไข
                  </v-btn>
                  <v-btn large class="grad-danger-bg white--text mobile_btn" type="button" style="font-size: 18px"
                    @click="modal_edit = false">
                    ยกเลิก
                  </v-btn>
                </div>
              </v-form>
            </v-card>
          </div>
        </v-dialog>
        <!-- MODAL -->
      </v-card>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { HTTP } from '@/axios.js'
import { HTTP_ARIN } from '@/axios_arin.js'
import { DataStore, } from 'vue-thailand-address';
import {
  formatNumber,
  isTelephone,
  onlyForCurrency,
  onlyForNumberCredit,
  onPaste,
  taxNumber,
  validateEmail
} from "@/js/handler";
const mainDataStore = new DataStore();
const subDataStore = new DataStore();

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      mainDataStore,
      subDataStore,
      loading_page: false,
      loading_data: false,
      loading_modal: false,
      disabled_status: false,
      title_add: 1,
      search: null,
      alert_success: false,
      modal_details: false,
      modal_edit: false,
      modal_delete: false,
      status_1: 'บุคคลธรรมดา',
      status_2: 'นิติบุคคล',
      alert_reset: false,
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      phoneRules: [v => (v.length > 8) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      taxRules: [v => (v.length === 13) || "เลขเสียภาษีไม่ถูกต้อง !",],
      creditRules: [v => !!v && (v <= 1000000) || 'ยอดเครดิตไม่ควรเกิน 1,000,000 บาท หรือ ห้ามว่าง'],
      credit_dayRules: [v => !!v || 'กรุณากรอกจำนวนวันในการติดเครดิต'],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      details_get: {
        id: null,
        code: null,
        is_clinic: null,
        is_deliveryfreecnx: null,
        name: null,
        customer_type: null,
        customer_paylater: null,
        type: null,
        telephone: '',
        tax_number: '',
        email: '',
        credit_balance: '',
        credit_day: '',
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postcode: null,
        address_delivery: null,
        postcode_delivery: null,
        province_delivery: null,
        sub_district_delivery: null,
        district_delivery: null,
        is_delivery_same_address: null,
      },
      headers: [],
      all_customer: [],
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    onlyNumberCredit: function (evt, number) {
      return onlyForNumberCredit(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    duplicate_address() {
      if (this.details_get.type_user === 2 && this.details_get.delivery_type === 0) {
        this.details_get.address_delivery = this.details_get.address;
        this.details_get.sub_district_delivery = this.details_get.sub_district;
        this.details_get.district_delivery = this.details_get.district;
        this.details_get.province_delivery = this.details_get.province;
        this.details_get.postcode_delivery = this.details_get.postcode;
      }
    },
    unduplicate_address() {
      this.details_get.address_delivery = null;
      this.details_get.sub_district_delivery = null;
      this.details_get.district_delivery = null;
      this.details_get.province_delivery = null;
      this.details_get.postcode_delivery = null;
    },
    clear_address() {
      this.details_get.address_delivery = null;
      this.details_get.sub_district_delivery = null;
      this.details_get.district_delivery = null;
      this.details_get.province_delivery = null;
      this.details_get.postcode_delivery = null;
    },
    checkLoading() {
      this.loading_page = true
      HTTP.post('/customers/customerlist', {
        customer_type: this.title_add
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.all_customer = res.data.object
        }
      })
    },
    async page(type) {
      this.title_add = type;
      if (type === 1 && this.$store.state.status === 1) {
        this.headers = [
          {
            text: 'รหัสลูกค้า',
            value: 'customer_code',
            fixed: true,
            width: '125px',
          },
          {
            text: 'ชื่อลูกค้า',
            value: 'name',
            fixed: true,
            width: '450px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '90px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'รีเซ็ตรหัสผ่าน',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'POS',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
        this.getCustomer();
      }
      else if (type === 1 && this.$store.state.status === 2) {
        this.headers = [
          {
            text: 'รหัสลูกค้า',
            value: 'customer_code',
            fixed: true,
            width: '125px',
          },
          {
            text: 'ชื่อลูกค้า',
            value: 'name',
            fixed: true,
            width: '450px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '90px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
        this.getCustomer();
      }
      if (type === 2 && this.$store.state.status === 1) {
        this.headers = [
          {
            text: 'รหัสลูกค้า',
            value: 'customer_code',
            fixed: true,
            width: '125px',
          },
          {
            text: 'ชื่อลูกค้า',
            value: 'name',
            fixed: true,
            width: '450px',
          },
          {
            text: 'วงเงินเครดิต',
            value: 'credit',
            fixed: true,
            width: '180px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '90px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'รีเซ็ตรหัสผ่าน',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'POS',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
        this.getCustomer();
      }
      else if (type === 2 && this.$store.state.status === 2) {
        this.headers = [
          {
            text: 'รหัสลูกค้า',
            value: 'customer_code',
            fixed: true,
            width: '125px',
          },
          {
            text: 'ชื่อลูกค้า',
            value: 'name',
            fixed: true,
            width: '450px',
          },
          {
            text: 'วงเงินเครดิต',
            value: 'credit',
            fixed: true,
            width: '150px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '90px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'POS',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
        this.getCustomer();
      }
    },
    delAlert(id) {
      Swal.fire({
        title: 'คุณต้องลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.getDelete(id)
        }
      });
    },
    editAlert() {
      Swal.fire('แก้ไขข้อมูลเรียบร้อย', '', 'success');
    },
    getCustomer() {
      this.loading_data = true
      HTTP.post('/customers/customerlist', {
        customer_type: this.title_add
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_data = false
          this.all_customer = res.data.object
        }
      })
    },
    getDetails(id) {
      this.modal_details = true
      this.loading_modal = true
      HTTP.post('/customers/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.details_get.id = res.data.object.id;
          this.details_get.customer_type = res.data.object.customer_type;
          this.details_get.code = res.data.object.customer_code;
          this.details_get.is_clinic = res.data.object.is_clinic;
          this.details_get.customer_paylater = res.data.object.customer_paylater;
          this.details_get.is_deliveryfreecnx = res.data.object.is_deliveryfreecnx;
          this.details_get.type = res.data.object.customer_status;
          this.details_get.name = res.data.object.name;
          this.details_get.telephone = res.data.object.telephone;
          this.details_get.email = res.data.object.email;
          if (res.data.object.credit !== null) {
            this.details_get.credit_balance = res.data.object.credit;
          }
          else {
            this.details_get.credit_balance = ''
          }
          if (res.data.object.credit_day !== null) {
            this.details_get.credit_day = res.data.object.credit_day;
          }
          else {
            this.details_get.credit_day = ''
          }
          this.details_get.tax_number = res.data.object.customer_personal_id;
          this.details_get.address = res.data.object.address;
          this.details_get.postcode = res.data.object.postcode;
          this.details_get.province = res.data.object.province;
          this.details_get.sub_district = res.data.object.sub_district;
          this.details_get.district = res.data.object.district;
          this.details_get.address_delivery = res.data.object.address_delivery;
          this.details_get.postcode_delivery = res.data.object.postcode_delivery;
          this.details_get.province_delivery = res.data.object.province_delivery;
          this.details_get.sub_district_delivery = res.data.object.sub_district_delivery;
          this.details_get.district_delivery = res.data.object.district_delivery;
          this.details_get.is_delivery_same_address = res.data.object.is_delivery_same_address;
        }
      })
    },
    getEdit(id) {
      this.modal_edit = true;
      this.loading_modal = true
      HTTP.post('/customers/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.details_get.id = res.data.object.id;
          this.details_get.customer_type = res.data.object.customer_type;
          this.details_get.customer_paylater = res.data.object.customer_paylater;
          this.details_get.code = res.data.object.customer_code;
          this.details_get.is_clinic = res.data.object.is_clinic;
          this.details_get.is_deliveryfreecnx = res.data.object.is_deliveryfreecnx;
          this.details_get.type = res.data.object.customer_status;
          this.details_get.name = res.data.object.name;
          this.details_get.telephone = res.data.object.telephone;
          this.details_get.email = res.data.object.email;
          if (res.data.object.credit !== null) {
            this.details_get.credit_balance = res.data.object.credit;
          }
          else {
            this.details_get.credit_balance = ''
          }
          if (res.data.object.credit_day !== null) {
            this.details_get.credit_day = res.data.object.credit_day;
          }
          else {
            this.details_get.credit_day = ''
          }
          this.details_get.tax_number = res.data.object.customer_personal_id;
          this.details_get.address = res.data.object.address;
          this.details_get.postcode = res.data.object.postcode;
          this.details_get.province = res.data.object.province;
          this.details_get.sub_district = res.data.object.sub_district;
          this.details_get.district = res.data.object.district;
          this.details_get.address_delivery = res.data.object.address_delivery;
          this.details_get.postcode_delivery = res.data.object.postcode_delivery;
          this.details_get.province_delivery = res.data.object.province_delivery;
          this.details_get.sub_district_delivery = res.data.object.sub_district_delivery;
          this.details_get.district_delivery = res.data.object.district_delivery;
          this.details_get.is_delivery_same_address = res.data.object.is_delivery_same_address;
        }
      });
    },
    updateCustomer() {
      if (this.details_get.is_clinic === true) {
        this.details_get.is_clinic = 1
      }
      else {
        this.details_get.is_clinic = 0
      }
      if (this.details_get.is_deliveryfreecnx === true || this.details_get.is_deliveryfreecnx == 1) {
        this.details_get.is_deliveryfreecnx = 1
      } else {
        this.details_get.is_deliveryfreecnx = 0
      }
      if (this.title_add === 1) {
        if (this.$refs.update_form.validate()) {
          if (this.details_get.credit_balance <= 1000000) {
            if (this.details_get.customer_paylater == false) {
              this.customer_paylater = 0
            } else {
              this.customer_paylater = 1
            }

            let data = {
              customer_status: this.details_get.type,
              is_clinic: this.details_get.is_clinic,
              is_deliveryfreecnx: this.details_get.is_deliveryfreecnx,
              id: this.details_get.id,
              name: this.details_get.name,
              telephone: this.details_get.telephone,
              email: this.details_get.email,
              credit: this.details_get.credit_balance,
              credit_day: this.details_get.credit_day,
              customer_paylater: this.customer_paylater,
              customer_personal_id: this.details_get.tax_number,
              address: this.details_get.address,
              postcode: this.details_get.postcode,
              province: this.details_get.province,
              sub_district: this.details_get.sub_district,
              district: this.details_get.district,
              address_delivery: null,
              sub_district_delivery: null,
              district_delivery: null,
              province_delivery: null,
              postcode_delivery: null,
              is_delivery_same_address: this.details_get.is_delivery_same_address,
            }
            if (this.details_get.type == 2) {
              data = {
                customer_status: this.details_get.type,
                is_clinic: this.details_get.is_clinic,
                is_deliveryfreecnx: this.details_get.is_deliveryfreecnx,
                id: this.details_get.id,
                name: this.details_get.name,
                telephone: this.details_get.telephone,
                email: this.details_get.email,
                credit: this.details_get.credit_balance,
                credit_day: this.details_get.credit_day,
                customer_paylater: this.details_get.customer_paylater,
                customer_personal_id: this.details_get.tax_number,
                address: this.details_get.address,
                postcode: this.details_get.postcode,
                province: this.details_get.province,
                sub_district: this.details_get.sub_district,
                district: this.details_get.district,
                address_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.address_delivery : this.details_get.address,
                sub_district_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.sub_district_delivery : this.details_get.sub_district,
                district_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.district_delivery : this.details_get.district,
                province_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.province_delivery : this.details_get.province,
                postcode_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.postcode_delivery : this.details_get.postcode,
                is_delivery_same_address: this.details_get.is_delivery_same_address,
              }
            }
            HTTP.post('/customers/edit', data).then((res) => {
              if (res.data.success === true) {
                this.modal_edit = false;
                this.editAlert();
                this.getCustomer();
              }
              else {
                Swal.fire({
                  title: 'ไม่สามารถดำเนินการได้ !',
                  text: res.data.message,
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                })
              }
            });
          }
          else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: 'เนื่องจากยอดเครดิตเกิน 1,000,000 บาท',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.details_get.credit_balance = ''
            })
          }
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'กรุณาตรวจสอบข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.$refs.update_form.validate()
          })
        }
      }
      else if (this.title_add === 2) {
        if (this.$refs.update_form.validate()) {
          if (this.details_get.credit_balance <= 1000000) {
            let data = {
              customer_status: this.details_get.type,
              is_clinic: this.details_get.is_clinic,
              is_deliveryfreecnx: this.details_get.is_deliveryfreecnx,
              id: this.details_get.id,
              name: this.details_get.name,
              telephone: this.details_get.telephone,
              email: this.details_get.email,
              credit: this.details_get.credit_balance,
              credit_day: this.details_get.credit_day,
              customer_personal_id: this.details_get.tax_number,
              address: this.details_get.address,
              postcode: this.details_get.postcode,
              province: this.details_get.province,
              sub_district: this.details_get.sub_district,
              district: this.details_get.district,
              address_delivery: null,
              sub_district_delivery: null,
              district_delivery: null,
              province_delivery: null,
              postcode_delivery: null,
              is_delivery_same_address: this.details_get.is_delivery_same_address,
            }
            if (this.details_get.type == 2) {
              data = {
                customer_status: this.details_get.type,
                is_clinic: this.details_get.is_clinic,
                is_deliveryfreecnx: this.details_get.is_deliveryfreecnx,
                id: this.details_get.id,
                name: this.details_get.name,
                telephone: this.details_get.telephone,
                email: this.details_get.email,
                credit: this.details_get.credit_balance,
                credit_day: this.details_get.credit_day,
                customer_personal_id: this.details_get.tax_number,
                address: this.details_get.address,
                postcode: this.details_get.postcode,
                province: this.details_get.province,
                sub_district: this.details_get.sub_district,
                district: this.details_get.district,
                address_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.address_delivery : this.details_get.address,
                sub_district_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.sub_district_delivery : this.details_get.sub_district,
                district_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.district_delivery : this.details_get.district,
                province_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.province_delivery : this.details_get.province,
                postcode_delivery: this.details_get.is_delivery_same_address == 1 ? this.details_get.postcode_delivery : this.details_get.postcode,
                is_delivery_same_address: this.details_get.is_delivery_same_address,
              }
            }
            HTTP.post('/customers/edit', data).then((res) => {
              if (res.data.success === true) {
                this.modal_edit = false;
                this.editAlert();
                this.getCustomer();
              }
              else {
                Swal.fire({
                  title: 'ไม่สามารถดำเนินการได้ !',
                  text: res.data.message,
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                })
              }
            });
          }
          else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: 'เนื่องจากยอดเครดิตเกิน 1,000,000 บาท',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.details_get.credit_balance = ''
            })
          }
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'กรุณาตรวจสอบข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.$refs.update_form.validate()
          })
        }
      }
    },
    async getDelete(id) {
      await HTTP.post('/customers/delete', {
        id: id
      }).then(async (res) => {
        if (res.data.success === true) {
          await HTTP_ARIN.get('/stores/delete/' + id).then((response) => {
            if (response.data.successful === true) {
              Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
              this.getCustomer();
            }
          });
        }
      })
    },
    password_reset(id) {
      Swal.fire({
        title: 'คุณต้องการรีเซ็ตรหัสผ่านหรือไม่ ?',
        text: 'รหัสผ่านจะถูก รีเซ็ตเป็นค่าเริ่มต้น !',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/customers/reset', {
            customer_id: id,
          }).then((result) => {
            if (result.data.success === true) {
              this.alert_reset = true
              setTimeout(() => this.alert_reset = false, 2000)
            }
          })
        }
      })
    },
    changeStatus(id, status) {
      if (status == false) {
        status = 0
      }
      else if (status == true) {
        status = 1
      }
      this.disabled_status = true
      HTTP.post('/customers/updatestatus', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.disabled_status = false
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 1000);
        }
      })
    },
    checkLogIn() {
      if (this.$store.state.access_token === null) {
        this.$store.commit('logout_success');
        this.$router.push('/login');
      }
      else if (this.$store.state.userDetail.manage_customer_list == 0 && this.$store.state.userDetail.manage_customer_create == 0 && this.$store.state.userDetail.manage_customer_edit == 0 && this.$store.state.userDetail.manage_customer_delete == 0) {
        this.$router.push('/retailer');
      }
    },
    open_pos(customer_code, id) {
      Swal.fire({
        title: 'เปิดระบบ POS',
        text: 'คุณต้องการเปิดระบบ POS ร้านนี้หรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed) {
          HTTP_ARIN.post('/stores/create/' + customer_code, null).then((res) => {
            if (res.data.successful === true) {
              HTTP.get('/update/status/open/post/' + id).then((response) => {
                if (response.data.success === true) {
                  this.checkLoading()
                }
              })
            }
          })
        }
      })
    },
  },

  beforeMount() {
    this.checkLogIn()
    this.checkLoading()
    this.page(1)
  },
}
</script>
<style scoped>
.pos-main-bg {
  background-color: #957E5D !important;
  color: #FFF;
}

.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.border_input {
  border: grey solid 1px;
  border-radius: 5px;
  padding: 10px;
}

.custom_css>>>input {
  font-size: 18px;
  color: black;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}

.custom_css>>>input:hover {
  border-color: black;
}

.custom_css>>>input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
}

.tri_grid {
  display: grid;
  grid-template-columns: 25% 35% 40%;
  grid-gap: 15px 0;
}

.four_grid {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-gap: 15px 0;
}

.grid_flex {
  display: flex;
}

.mobile_btn {
  width: 20%;
  margin: 5px;
}

@media only screen and (max-width: 500px) {
  .grid_flex {
    display: block;
  }

  .tri_grid {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .four_grid {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100%;
  }

  .mobile_btn {
    width: 95%;
  }
}
</style>
